import { ref } from "vue"
import Tr from "@/translations"

/**
 * Articulos de una subcategoria del catalogo, resueltos por el par
 * (slug de categoria, slug de subcategoria).
 *
 * Mismo criterio que getArticlesFromCategory: el 404 del backend se pinta como
 * lista vacia, no como error de carga.
 */
const getArticlesFromSubCategory = () => {

    const articles = ref([])
    const error = ref(null)
    const isLoading = ref(false)

    const load = async (categorySlug, subCategorySlug) => {
        isLoading.value = true
        error.value = null

        try {
            const url = process.env.VUE_APP_ROOT_API + "articles/by-subcategory/"
                + encodeURIComponent(categorySlug) + "/"
                + encodeURIComponent(subCategorySlug) + "/" + Tr.currentLocale

            const response = await fetch(url)
            const data = await response.json()

            if (data.error || Number(data.code) !== 200) {
                articles.value = []
                error.value = { code: Number(data.code) || response.status, message: data.message }
                return
            }

            articles.value = data.results || []
        } catch (err) {
            articles.value = []
            // code 0 = no hubo respuesta del servidor
            error.value = { code: 0, message: err.message }
        } finally {
            isLoading.value = false
        }
    }

    return { articles, error, isLoading, load }
}

export default getArticlesFromSubCategory
